import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SettingsProvider } from './context/SettingsContext';
import { AdminProvider, useAdmin } from './context/AdminContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import AdminLogin    from './admin/AdminLogin';
import AdminLayout   from './admin/AdminLayout';
import AdminDashboard     from './admin/AdminDashboard';
import AdminAppointments  from './admin/AdminAppointments';
import AdminReviews       from './admin/AdminReviews';
import AdminGallery       from './admin/AdminGallery';
import AdminServices      from './admin/AdminServices';
import AdminOffers        from './admin/AdminOffers';
import AdminSettings      from './admin/AdminSettings';
import LoadingScreen from './components/LoadingScreen';
import './styles/main.css';
import './styles/admin.css';

function AdminGuard({ children }) {
  const { admin, checking } = useAdmin();
  if (checking) return <div className="admin-checking">Loading…</div>;
  return admin ? children : <Navigate to="/admin/login" replace />;
}

function CustomerLayout() {
  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </>
  );
}

export default function App() {
  const [loaded, setLoaded] = useState(false);

  return (
    <SettingsProvider>
      <AdminProvider>
        {!loaded && <LoadingScreen onDone={() => setLoaded(true)} />}
        <BrowserRouter>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminGuard><AdminLayout /></AdminGuard>}>
              <Route index element={<AdminDashboard />} />
              <Route path="appointments" element={<AdminAppointments />} />
              <Route path="reviews"      element={<AdminReviews />} />
              <Route path="gallery"      element={<AdminGallery />} />
              <Route path="services"     element={<AdminServices />} />
              <Route path="offers"       element={<AdminOffers />} />
              <Route path="settings"     element={<AdminSettings />} />
            </Route>
            <Route path="/*" element={<CustomerLayout />} />
          </Routes>
        </BrowserRouter>
      </AdminProvider>
    </SettingsProvider>
  );
}